export const financeHeading = [
    { name: "ID" },
    { name: "IN/OUT" },
    { name: "CATOGORIES" },
    { name: "DESCRIPTION" },
    { name: "AMOUNT" },
    { name: "REMARKS" },
    { name: "DATE" },
    { name: "ACTION" },
];